import classnames from 'classnames/bind'

// Libs

// Components
import Icon from '@/assets/icons'

// Constants
import { ORDER } from '@/constants/mall'

// Types

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type SortItemProps = {
  label: string
  value: string
  order: string
  handleSortClick: ({ value, hasOrder }: { value: string; hasOrder: boolean }) => void
  isActive: boolean
  hasOrder?: boolean
}

const SortItem = (props: SortItemProps) => {
  const { label, value, order, handleSortClick, isActive, hasOrder = true } = props

  return (
    <div className={cx('sort-item')} onClick={() => handleSortClick({ value, hasOrder })}>
      <p className={cx('sort-item-text', { isActive })}>{label}</p>

      {hasOrder && (
        <div className={cx('sort-item-icon', { isActive })}>
          {isActive ? order === ORDER.ASCEND ? <Icon.SortDescend /> : <Icon.SortAscend /> : <Icon.SortAscend />}
        </div>
      )}
    </div>
  )
}

export default SortItem
